export enum CompanyStage {
  PRE_COMMERCIAL = 'PRE_COMMERCIAL',
  COMMERCIAL_STAGE_UNPROFITABLE = 'COMMERCIAL_STAGE_UNPROFITABLE',
  COMMERCIAL_STAGE_PROFITABLE = 'COMMERCIAL_STAGE_PROFITABLE',
}

export const CompanyStageLabels: Record<CompanyStage, string> = {
  [CompanyStage.PRE_COMMERCIAL]: 'Pre-Commercial',
  [CompanyStage.COMMERCIAL_STAGE_PROFITABLE]: 'Commercial Stage - Profitable',
  [CompanyStage.COMMERCIAL_STAGE_UNPROFITABLE]: 'Commercial Stage - Unprofitable'
};
